module.exports = __webpack_public_path__ + "img/thumbnail_CollaredPeccary_m_leucistic.ff0a1458.png";